export default function Faq({ faq }) {
  if (faq)
    return (
      <>
        <main className="page-container text-container text-cover-container">
          <div
            className="text-cover-header text-center"
            style={{ backgroundImage: "url(/faq.jpg)" }}
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-lg-10 col-xl-9">
                  <h1 className="page-title text-title text-cover-header-title text-white mb-0">
                    پرسش های متداول
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10 col-xl-9">
                <div className="page-context text-context text-cover-context px-md-40 py-25 py-sm-30 py-md-40 rounded-top">
                  <div className="faq-questions-list particle-helper">
                    <div className="container">
                      <div className="container">
                        <div className="faq-question-section mb-30">
                          <div className="text-center mt-5 mb-20">
                            <h3 className="package-faq-title mb-15">
                              پاسخ به سوالات رایج شما
                            </h3>
                            <h4
                              className="package-faq-subtitle"
                              style={{ textAlign: "justify" }}
                            />
                          </div>

                          {faq.map((item, index) => {
                            let id = `faqQuestion${item.id}${index}`;
                            return (
                              <div
                                key={index}
                                className="faq-question bg-white rounded mt-20"
                              >
                                <a
                                  href="#"
                                  className="faq-question-title d-flex justify-content-between w-100 align-items-center py-10 px-15 collapsed"
                                  data-toggle="collapse"
                                  data-target={`#${id}`}
                                  aria-expanded="false"
                                >
                                  <div className="d-flex align-items-center">
                                    {item.title}
                                  </div>
                                  <i
                                    className="fa fa-angle-down"
                                    aria-hidden="true"
                                  />
                                </a>
                                <div className="faq-answer collapse" id={id}>
                                  <div
                                    className="m-0 pt-20"
                                    style={{
                                      padding: "0px 17px",
                                      textAlign: "justify",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: item.rule,
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
}
